<script setup lang="ts">
import { computed, onMounted } from 'vue';
import useCartStore from '@shop/store/cart';
import type { Props } from './CartHeader.types';
import useWishlistStore from '@shop/store/wishlist';

const props = withDefaults(defineProps<Props>(), {
  wishlistUri: '',
  cartUri: '',
});

const cartStore = useCartStore();
const wishlistStore = useWishlistStore();

const cartQty = computed(() => cartStore.cartQty);
const wishlistQty = computed(() => wishlistStore.itemCount);

onMounted(() => {
  cartStore.syncQtyFromStorage();
  wishlistStore.syncFromStorage();
});
</script>

<template>
  <div class="cartheader__container">
    <a :href="props.wishlistUri" class="cartheader__button-wishlist cartheader__button">
      <i class="cartheader__wishlist-icon icon icon--wishlist icon--showleft"></i>
      <span
        v-cloak
        :class="[
          'cartheader__wishlist-badge',
          'cartheader__badge',
          'badge__container',
          !wishlistQty && 'badge__container--default',
        ]"
      >
        {{ wishlistQty }}
      </span>
    </a>
    <a :href="props.cartUri" class="cartheader__button-cart cartheader__button">
      <i class="cartheader__cart-icon icon icon--cart icon--showleft"></i>
      <span
        v-cloak
        :class="[
          'cartheader__cart-badge',
          'cartheader__badge',
          'badge__container',
          !cartQty && 'badge__container--default',
        ]"
      >
        {{ cartQty }}
      </span>
    </a>
  </div>
</template>

<style lang="scss" scoped>
@use '@shop/assets/scss/abstracts/variables' as *;
@use '@shop/assets/scss/abstracts/mixins' as *;

.cartheader {
  &__container {
    position: relative;
  }

  &__button {
    display: inline-block;
    position: relative;
    vertical-align: top;
    height: 30px;

    @include mobile-up {
      height: 40px;
    }
  }

  &__button-wishlist {
    width: 35px;
    font-size: 30px;
    margin-right: 5px;

    @include mobile-up {
      font-size: 38px;
      width: 38px;
    }
  }

  &__button-cart {
    font-size: 30px;
    width: 44px;

    @include mobile-up {
      width: 55px;
      font-size: 38px;
    }
  }

  &__wishlist-badge {
    top: 5px;
    right: -2px;

    @include mobile-up {
      right: -3px;
    }
  }

  &__cart-badge {
    top: 5px;
    right: 9px;

    @include mobile-up {
      right: 8px;
    }
  }

  &__badge {
    position: absolute;
    font-weight: 100;
    font-size: 12px;
    width: 18px;
    height: 18px;
    line-height: 18px;
    padding: 0;

    @include mobile-up {
      font-size: 14px;
      padding-left: 2px;
      width: 20px;
      height: 20px;
      line-height: 20px;
    }
  }

  &__wishlist-icon {
    margin-top: 1px;
  }

  &__cart-icon,
  &__wishlist-icon {
    color: $darkgray;
  }
}
</style>
